import { CommonModule, LocationStrategy } from "@angular/common";
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { NavigationExtras, Router, RouterModule } from "@angular/router";
import { Enum } from "../helpers/enums/enum";
import { CommunicationService } from "../services/communication.service";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SeamlessHeaderComponent } from "../shared/seamless-header.component";

@Component({
  selector: "app-reduce-debt-capfin",
  standalone: true,
  imports: [CommonModule, SeamlessHeaderComponent, RouterModule],
  templateUrl: "./reduce-debt-capfin.component.html",
  styleUrl: "./reduce-debt-capfin.component.css",
})
export class ReduceDebtCapfinComponent {
  @ViewChild("DCCallbackConfirmationModel", { static: false })
  DCCallbackConfirmationModel: ElementRef;
  @ViewChild("callbackSuccessModel", { static: false })
  callbackSuccessModel: ElementRef;
  @ViewChild("callbackStatusModel", { static: false })
  callbackStatusModel: ElementRef;

  allowNavigation = false;
  username: string = "";
  userName = "";
  modalOptions: NgbModalOptions;
  moved = false;
  displayDbQuoteSection = false;
  callbackErrorMsg = "";
  callbackSuccessMsg = "";
  monthlyInstalment;
  dbc_Dcrs;
  setPosition = false;
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private communicationService: CommunicationService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      keyboard: false,
    };
  }

  ngOnInit() {
    localStorage.setItem("PageUrls", "onboarding");
    let userDataStr = localStorage.getItem("apiUserModel");
    let userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.userName = userData?.given_name;

    let dcData = JSON.parse(sessionStorage.getItem("loadUserType"));
    this.monthlyInstalment = dcData ? dcData?.monthlyInstallment : null;
    this.dbc_Dcrs = dcData ? dcData?.dbC_DCRS : null;
    setTimeout(() => {
      this.moved = true;
    }, 2000);
    setTimeout(() => {
      this.displayDbQuoteSection = true;
      this.setPosition = true;
      this.renderer.addClass(this.el.nativeElement, "bg-active");
    }, 2500);
  }

  DBLeadInsert(campaignSource: string) {
    const param = {
      CampaignSource: campaignSource,
      Referrer: "Justmoney",
      WebSource: "CreditSav_Solution",
      SessionId: sessionStorage.getItem("sessionId"),
    };
    this.idmLeadInsert(param, false);
  }

  closePopup() {
    this.modalService.dismissAll();
    this.callbackErrorMsg = "";
    this.callbackSuccessMsg = "";
    this.router.navigate(["/ready"]);
  }

  idmLeadInsert(param?: any, RequestFromBanner?: boolean) {
    this.callbackErrorMsg = "";
    this.callbackSuccessMsg = "";
    this.communicationService.leadCallbackSource(param).subscribe({
      next: (data: any) => {
        this.callbackSuccessMsg = "DebtBusters expert will call them back soon";
        this.modalService.dismissAll();
        if (!RequestFromBanner) {
          this.modalService.open(this.callbackStatusModel, this.modalOptions);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.callbackErrorMsg = "Something went wrong. Please try again later";
        this.modalService.open(this.callbackStatusModel, this.modalOptions);
      },
    });
  }
  SkipCallback() {
    this.router.navigate(["/ready"]);
  }
  cleanupStorage() {
    localStorage.removeItem("OnLoadCheck");
  }
  allowUserNavigation() {
    this.allowNavigation = true;
  }

  navigateToDashboard() {
    sessionStorage.setItem("capfinOnBoardingVisited", "true");
    this.router.navigateByUrl("/portal/dashboard?onbId=capfinOnboarding");
  }
}
